// @no-flow
// https://github.com/styled-components/styled-components/issues/182
import React from "react"
import styled, { css } from "styled-components"

export const deviceSizes = {
  desktopExtraLarge: 3120,
  desktopMediumLarge: 1500,
  desktopLarge: 1200,
  desktop: 1070,
  tablet: 768,
  small: 576,
  largerPhone: 475,
  phone: 320,
}

export const media = Object.keys(deviceSizes).reduce((accumulator, label) => {
  accumulator[label] = (...args) => css`
    @media (max-width: ${deviceSizes[label] / 16}em) {
      ${css(...args)};
    }
  `
  return accumulator
}, {})

const ResponsiveContainer = styled.div`
  display: ${props => (props.from ? "none" : "inherit")};

  ${props =>
    props.from &&
    media[props.from]`
    display: inherit
  `}

  ${props =>
    props.to &&
    media[props.to]`
    display: none;
  `}
`

export const Responsive = props => (
  <ResponsiveContainer from={props.from} to={props.to} {...props}>
    {props.children}
  </ResponsiveContainer>
)
